import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './i18n/bundled/en.json';
import translationPL from './i18n/bundled/pl.json';
import translationRU from './i18n/bundled/ru.json';

// Add type declaration for returnNull
declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

/**
 * Bundled JSON is copied from public/locales (en + pl + ru translation.json); see npm run sync:i18n.
 * Runtime fetch of locale files often failed in production (path, caching), so pl used en strings.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'pl', 'ru'],
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    ns: ['translation'],
    defaultNS: 'translation',
    resources: {
      en: { translation: translationEN },
      pl: { translation: translationPL },
      ru: { translation: translationRU },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
    },
    returnNull: false,
  });

export default i18n;
